/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { checkComponentPermission, exportCommonFile, idNamingConversion } from '../../../../../helpers/utilities';
import usePrevious from "../../../../Shared/components/Previous";
import { useSelector, useDispatch } from "react-redux";
import { TextField, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { NavLink } from "react-router-dom";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ListTable } from './ListTable';
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import actions from "../../redux/actions";
import productActions from "../../../Setup/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const StockTransaction = (props) => {
    const { getData } = useSelector(state => state.crudReducer);

    const [search, setSearch] = useState('');
    const [loadMore, setLoadMore] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [topBar, setTopBar] = useState();
    const [type, setType] = useState('All');
    const [reportList, setReportList] = useState('');
    const [reportListAll, setReportListAll] = useState('');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("product");

    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const dispatch = useDispatch();


    const dispatchFilter = () => {
        if (type === 'All' || topBar?.productId || topBar?.groupId) {
            setLoadMore(false);
            let url = type + '/' + (topBar?.productId ? topBar?.productId : 0) + '/' + (topBar?.groupId ? topBar?.groupId : 0);
            dispatch({
                type: crudActions.GET_DETAILS_START,
                url: `productWiseReport/${url}`,
                skip: 0
            });
        }
    }

    useEffect(() => {
        dispatch({
            type: actions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: productActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                order: 'id desc'
            }
        });
    }, []);

    useEffect(() => {
        dispatchFilter();
        return () => {
            dispatch({ type: crudActions.CLEAR_CRUD_DETAILS_START });
        }
    }, [topBar]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setReportList(reportListAll);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setReportList(reportListAll?.filter((el) => {
                        return (el?.product?.match(new RegExp(search, "i")) ||
                            el?.productId?.match(new RegExp(search, "i")) ||
                            el?.soldUnit?.match(new RegExp(search, "i")) ||
                            el?.purchaseUnit?.match(new RegExp(search, "i")))
                    }));
                }, 500);
            }
        }
    }, [search]);

    const handleTypeChange = (value) => {
        setType(value);
        setTopBar({
            ...topBar,
            groupId: '',
            productId: ''
        })
    }


    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                let a = [];
                getData && Object.keys(getData).length > 0 && Object?.entries(getData)?.map(([key, value]) => {
                    return value.map((v) => { return a.push(v) })
                });
                setReportList(a);
                setReportListAll(a)
                setLoadMore(true);
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        if (sortOrder === 'desc') {
            setReportList(reportList.sort((a, b) => b[sortBy]?.localeCompare(a[sortBy])));
        } else {
            setReportList(reportList.sort((a, b) => a[sortBy]?.localeCompare(b[sortBy])));
        }
    }

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader
                {...props}
                img={ProductIcon}
                title={'Product'}
                closeLink={'/product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Stock Transaction', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableMarginProduct, classes.listTableMarginProductBottom)}>
                <PrimaryCard
                    title={'Stock Transaction'}
                    component={
                        <>
                            <Row align="middle" className={classes.priceTopbar}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Stock Transaction', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Product Name'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                id={idNamingConversion('Search', 'stockTransaction', 'TextField')}
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent, classes.customerLabelNone, classes.removeUnderline)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterMyProduct)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            <div className={clsx(classes.fillterDropdown, classes.customFilterNone)}>
                                                {
                                                    roleManagement !== '' && checkComponentPermission('Stock Transaction', 'Action', 'Product specification Filter') &&
                                                    <>
                                                        <FormControl
                                                            className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                                            variant={'standard'}
                                                            id={idNamingConversion('Product specification Filter', 'stockTransaction', 'Radio')}
                                                            fullWidth>
                                                            <RadioGroup
                                                                row
                                                                defaulfValue={'All'}
                                                                value={type}
                                                                onChange={(e) => handleTypeChange(e.target.value)}>
                                                                <FormControlLabel value="All" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="All" />
                                                                <FormControlLabel value="SPECIFIC" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="Product" />
                                                                <FormControlLabel value="GROUP" control={<Radio
                                                                    checkedIcon={<UnSelectedIcon />}
                                                                    icon={<SelectedIcon />}
                                                                />} label="Group" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {
                                                            type !== 'All' && <>
                                                                {
                                                                    type === 'GROUP' ?
                                                                        <AutoCompleteComponent
                                                                            customLabel={"All Products Group"}
                                                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                                            details={productGroupDetails}
                                                                            parentValue={customObject(productGroupDetails, topBar?.groupId)}
                                                                            position={"bottom"}
                                                                            customClasses={classes.customFilterNone}
                                                                            variant={'outlined'}
                                                                            id={idNamingConversion('All Products Group', 'stockTransaction', 'DropDown')}
                                                                            onChangeText={(data) => {
                                                                                if (data === '') {
                                                                                    setTopBar({
                                                                                        ...topBar, groupId: ''
                                                                                    })
                                                                                }
                                                                            }}
                                                                            onChange={(data) => {
                                                                                setTopBar({
                                                                                    ...topBar, groupId: data?.id
                                                                                })
                                                                            }}
                                                                        /> : <AutoCompleteComponent
                                                                            customLabel={"All Products"}
                                                                            heads={[{ 'key': 'productName', 'name': 'Name' }]}
                                                                            details={myProductdetails}
                                                                            parentValue={customObject(myProductdetails, topBar?.productId)}
                                                                            position={"bottom"}
                                                                            id={idNamingConversion('All Products', 'stockTransaction', 'DropDown')}
                                                                            customClasses={classes.customFilterNone}
                                                                            variant={'outlined'}
                                                                            onChangeText={(data) => {
                                                                                if (data === '') {
                                                                                    setTopBar({
                                                                                        ...topBar, productId: ''
                                                                                    })
                                                                                }
                                                                            }}
                                                                            onChange={(data) => {
                                                                                setTopBar({
                                                                                    ...topBar, productId: data?.id
                                                                                })
                                                                            }}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </div>
                                            {
                                                roleManagement !== '' && checkComponentPermission('Stock Transaction', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'stockTransaction', 'Link')}
                                                    onClick={() => exportCommonFile('Stock Transaction', reportList, 'existing')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                details={reportList}
                                loadMore={loadMore}
                                loadMoreTask={() => { }}
                                loadMoreContent={false}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
        </Fragment>
    )
}

export default StockTransaction;